import { useDimension } from "@/shared/store/dimensions-store"
import Skeleton from "./Skeleton"

export default function HomeLoading({}) {
  const bottomSafeArea = useDimension((state) => state.bottomSafeArea)
  return (
    <div className="flex top-safe-padding flex-1 fixed inset-0 h-full w-full bg-[##f4f4f4] dark:bg-[#171717] flex-col px-4">
      <Skeleton h={80} style="flex justify-between items-center px-3 my-3">
        <div className="flex items-center gap-x-3">
          <Skeleton round h={48} w={48} inside />
          <Skeleton h={48} w={130} inside />
        </div>
        <Skeleton h={48} w={80} inside />
      </Skeleton>
      <div className="flex items-center justify-center gap-x-3">
        <Skeleton h={44} style="w-[50%] rounded-xl" />
        <Skeleton h={44} style="w-[50%] rounded-xl" />
      </div>
      <Skeleton h={36} w={160} style="my-3" />
      <div className="flex items-center justify-center gap-x-3">
        <Skeleton h={35} style="w-1/3" />
        <Skeleton h={35} style="w-1/3" />
        <Skeleton h={35} style="w-1/3" />
      </div>
      <Skeleton h={140} style="mt-3" />
      <Skeleton
        h={65 + bottomSafeArea}
        style="w-full fixed left-0 w-full bottom-0 rounded-tr-2xl rounded-tl-2xl"
      />
    </div>
  )
}
